export enum PlayerProfileLocation {
  HEADER = 'Header',
  EXPLORE_OTHER_PLAYERS = 'Explore Other Players',
  PAST_PERFORMANCE = 'Past Performance',
  WEEK_PROJECTIONS = 'Week Projections',
  FOOTER = 'Footer',
  KEY_INSIGHTS = 'Key Insights',
  GRADES = 'Grades',
  SEASON_STATS = 'Season Stats',
  GRADES_BY_GAME = 'Grades by Game',
}

export enum PlayerProfileScreenNames {
  NFL = 'NFL Player Profile',
  NCAA = 'NCAA Player Profile',
}

export enum PlayerProfileCtaNames {
  GRADES_PAYWALL = 'Grades Paywall',
  SEASON_STATS_PAYWALL = 'Season Stats Paywall',
  PAST_PERFORMANCE_PAYWALL = 'Past Performance Paywall',
  GAME_VIEW = 'Game View',
  GRADES_BY_GAME_PAYWALL = 'Grades by Game Paywall',
}

export enum PlayerProfileLinkNames {
  MOCK_DRAFT_SIMULATOR = 'Mock Draft Simulator',
  VIEW_PREMIUM_STATS = 'View Premium Stats',
  RANKINGS = 'Rankings',
}
